import { render, staticRenderFns } from "./serviceorder.vue?vue&type=template&id=3453cc52&scoped=true&"
import script from "./serviceorder.vue?vue&type=script&lang=js&"
export * from "./serviceorder.vue?vue&type=script&lang=js&"
import style0 from "./serviceorder.vue?vue&type=style&index=0&id=3453cc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453cc52",
  null
  
)

export default component.exports